var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 11.7002 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0049 4.21465C10.7708 3.98051 10.6537 3.68782 10.6537 3.39514C10.6537 2.75123 10.361 2.16586 9.95127 1.75611C9.54151 1.34635 8.95614 1.05366 8.31224 1.05366C8.01955 1.05366 7.72687 0.93659 7.49272 0.702443C6.81312 -0.0224676 5.74778 -0.186305 4.86667 0.210929C4.33945 0.44862 3.97347 1.05366 3.39514 1.05366C2.10733 1.05366 1.05366 2.10733 1.05366 3.39514C1.05366 3.68782 0.93659 3.98051 0.702443 4.21465C-0.234148 5.09271 -0.234148 6.61467 0.702443 7.49272C0.93659 7.72687 1.05366 8.01955 1.05366 8.31224C1.05366 8.95614 1.34635 9.54151 1.75611 9.95127C2.16586 10.361 2.75123 10.6537 3.39514 10.6537C3.68782 10.6537 3.98051 10.7708 4.21466 11.0049C4.68295 11.4732 5.26832 11.7074 5.85369 11.7074C6.43906 11.7074 7.02443 11.4732 7.49272 11.0049C7.72687 10.7708 8.01955 10.6537 8.31224 10.6537C9.60005 10.6537 10.6537 9.60005 10.6537 8.31224C10.6537 7.72376 11.2229 7.32286 11.4793 6.79319C11.891 5.94271 11.7241 4.88886 11.0049 4.21465Z",
    fill: "var(--fill-0, #158148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99023 0.484375C5.7639 0.135695 6.68867 0.283849 7.27344 0.907227V0.908203L7.28027 0.915039C7.56888 1.2036 7.93778 1.35352 8.3125 1.35352C8.86496 1.3536 9.37698 1.60558 9.73926 1.96777C10.1016 2.33012 10.3535 2.84286 10.3535 3.39551C10.3536 3.77013 10.5044 4.13824 10.793 4.42676L10.7998 4.43359C11.42 5.01506 11.5653 5.92597 11.209 6.66211C11.0962 6.89503 10.9262 7.08102 10.7275 7.35449C10.5462 7.6041 10.3535 7.91792 10.3535 8.3125C10.3534 9.43442 9.43442 10.3534 8.3125 10.3535C7.93775 10.3535 7.56889 10.5044 7.28027 10.793C6.86649 11.2066 6.35672 11.4072 5.85352 11.4072C5.3503 11.4072 4.84053 11.2067 4.42676 10.793C4.13824 10.5044 3.77013 10.3536 3.39551 10.3535C2.84286 10.3535 2.33012 10.1016 1.96777 9.73926C1.60558 9.37698 1.3536 8.86496 1.35352 8.3125C1.35352 7.93778 1.2036 7.56888 0.915039 7.28027L0.907227 7.27344C0.0975658 6.51392 0.0974515 5.19303 0.907227 4.43359L0.702148 4.21484L0.908203 4.43359L0.915039 4.42676C1.2034 4.13828 1.35342 3.77003 1.35352 3.39551C1.35352 2.27338 2.27338 1.35352 3.39551 1.35352C3.79381 1.35339 4.10023 1.14275 4.33594 0.957031C4.59617 0.751981 4.77108 0.583177 4.99023 0.484375Z",
    stroke: "url(#paint0_linear_0_150)",
    strokeOpacity: 0.3,
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.88059 7.90429C7.20388 7.90429 7.46596 7.64221 7.46596 7.31892C7.46596 6.99563 7.20388 6.73355 6.88059 6.73355C6.5573 6.73355 6.29522 6.99563 6.29522 7.31892C6.29522 7.64221 6.5573 7.90429 6.88059 7.90429Z",
    fill: "var(--fill-0, #DCFCEA)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.53484 5.56103C4.85813 5.56103 5.12021 5.29896 5.12021 4.97567C5.12021 4.65238 4.85813 4.3903 4.53484 4.3903C4.21155 4.3903 3.94947 4.65238 3.94947 4.97567C3.94947 5.29896 4.21155 5.56103 4.53484 5.56103Z",
    fill: "var(--fill-0, #DCFCEA)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.53484 7.90251C4.35923 7.90251 4.24216 7.84397 4.12508 7.7269C3.89093 7.49275 3.89093 7.14153 4.12508 6.90738L6.46656 4.56591C6.70071 4.33176 7.05193 4.33176 7.28607 4.56591C7.52022 4.80005 7.52022 5.15128 7.28607 5.38542L4.9446 7.7269C4.82752 7.84397 4.71045 7.90251 4.53484 7.90251Z",
    fill: "var(--fill-0, #DCFCEA)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.1,
    d: "M10.857 7.78539C10.6229 8.01954 10.5058 8.31222 10.5058 8.6049C10.5058 9.89272 9.45215 10.9464 8.16434 10.9464C7.87166 10.9464 7.57897 11.0635 7.34483 11.2976C6.87653 11.7659 6.29116 12 5.70579 12C5.12043 12 4.53506 11.7659 4.06676 11.2976C3.83261 11.0635 3.53993 10.9464 3.24725 10.9464C2.60334 10.9464 2.01797 10.6537 1.60821 10.2439L4.18384 7.66831L7.34483 4.50732L10.0678 1.8627C10.4775 2.27246 10.7702 2.85783 10.7702 3.50174C10.7702 3.79442 10.74 4.1561 10.9741 4.39025C11.7936 5.38538 11.7936 6.90734 10.857 7.78539Z",
    fill: "var(--fill-0, black)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_150",
    x1: 0,
    y1: 5.85369,
    x2: 11.7002,
    y2: 5.85369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DD5EA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountIcon);
export default __webpack_public_path__ + "static/media/discount-icon.145d9f69edb483f68901dadaa03ef89c.svg";
export { ForwardRef as ReactComponent };